<div class="container">
  <div class="row card">
    <div class="card-body col-md-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openLg(transcript)">
        View video transcript
      </button>
    </div>
  </div>
  <div class="row col-md-12">
    <h2 class="title">Additional Videos</h2>
    <div class="col-md-4 mb-3 text-center">
      <a (click)="openLg(scanPhotos)" class="resource-item-video">
        <img
          class="img-fluid"
          src="https://img.youtube.com/vi/7g7z_a6fC9o/0.jpg" />
        <span>How to Scan Photos By Stella Parris</span>
      </a>
    </div>
    <div class="col-md-4 mb-3 text-center">
      <a (click)="openLg(addPhotos)" class="resource-item-video">
        <img
          class="img-fluid"
          src="https://img.youtube.com/vi/vXRbPJT3gHo/0.jpg" />
        <span>How to Add Photos From Your Phone By Stella Parris</span>
      </a>
    </div>
    <div class="col-md-4 mb-3 text-center">
      <a (click)="openLg(searchPhotos)" class="resource-item-video">
        <img
          class="img-fluid"
          src="https://img.youtube.com/vi/dwIXzjBfSt0/0.jpg" />
        <span>How to Google Search for Photos By Stella Parris</span>
      </a>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - Uploading Photos</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6">
    <p>
      Great! Now you've chosen your five favorite stories. Let's talk about
      photographs. The photograph will enhance what you're writing about. It
      will bring that story to life, and for the reader, it makes it a lot
      better to have photographs, not just solid text all the time. Now that
      you've chosen your photographs, let's upload them. Click on the icon below
      to upload your photographs. If you need additional help, click on the
      resources tab.
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
<ng-template #scanPhotos let-modal>
  <iframe
    src="https://www.youtube.com/embed/7g7z_a6fC9o?autoplay=0&rel=0&loop=1&showinfo=0&modestbranding=1"
    height="300px"
    frameborder="0"></iframe>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>

<ng-template #addPhotos let-modal>
  <iframe
    src="https://www.youtube.com/embed/vXRbPJT3gHo?autoplay=0&rel=0&loop=1&showinfo=0&modestbranding=1"
    height="300px"
    frameborder="0"></iframe>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>

<ng-template #searchPhotos let-modal>
  <iframe
    src="https://www.youtube.com/embed/dwIXzjBfSt0?autoplay=0&rel=0&loop=1&showinfo=0&modestbranding=1"
    height="300px"
    frameborder="0"></iframe>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
